import { useState } from 'react';
import { translate } from 'react-switch-lang';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import SweetAlert from 'sweetalert2';
import { Practice } from '../../model/types';
import PracticeForm from './PracticeForm';

interface EditPracticeProps {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  practice: Practice;
  setPractices: React.Dispatch<React.SetStateAction<Practice[]>>;
  updatePracticeById: (id: number, data: Practice) => Promise<any>;
  t: (key: string) => string;
}

const EditPractice = ({ isOpen, setIsOpen, practice, setPractices, updatePracticeById, t }: EditPracticeProps) => {
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = async (data: Practice) => {
    setIsLoading(true);
    const response = await updatePracticeById(practice.id, { ...data, id: practice.id });
    setIsLoading(false);

    if (response?.status === 200) {
      setPractices((prev) => prev.map((t) => (t.id === practice.id ? { ...data, id: practice.id } : t)));
      setIsOpen(false);
      SweetAlert.fire(t('practice.updated'), t('practice.practice_updated'), 'success');
    } else {
      SweetAlert.fire(t('practice.error'), t('practice.err'), 'error');
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={() => setIsOpen(false)} centered>
      <ModalHeader toggle={() => setIsOpen(false)}>{t('practice.edit_practice')}</ModalHeader>
      <ModalBody>
        <PracticeForm
          defaultValues={practice}
          onSubmit={onSubmit}
          onCancel={() => setIsOpen(false)}
          isLoading={isLoading}
        />
      </ModalBody>
    </Modal>
  );
};

export default translate(EditPractice);
